"use client";

import { DownloadStemSplitGroup } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/DownloadStemSplitGroup";
import { LinkButton } from "@/components/links/LinkButton";
import { NormalText } from "@/components/text/NormalText";
import { EXPECTED_STEMS_COUNT } from "@/constants/stemSplit";
import { StemSplitGroupWithAudioNoDates } from "@/types/defs/stemSplit";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";

export function DoneStemSplitGroup({
  stemSplitGroup,
  open,
  setOpen,
}: {
  stemSplitGroup: StemSplitGroupWithAudioNoDates;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const isClient = useIsClient();

  const variantText = `${EXPECTED_STEMS_COUNT[stemSplitGroup.stemSplitType]} stems`;

  return (
    <div className="flex items-center gap-x-3">
      <LinkButton onClick={() => setOpen((prevOpen) => !prevOpen)}>
        {open ? "Less" : "More"}
      </LinkButton>
      <NormalText elementType="p" className="truncate">
        {isClient &&
          formatDateForOutput({
            date: new Date(stemSplitGroup.createdAtString),
            withTime: true,
            withYear: false,
          })}{" "}
        | {variantText} | {stemSplitGroup.name}
      </NormalText>
      <DownloadStemSplitGroup
        stemSplitGroup={stemSplitGroup}
        className="ml-auto"
      />
    </div>
  );
}
